import { flex, singleTextEllipsis } from '@byecode/ui'
import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 8px;
    border: 1px solid var(--color-gray-200);
`

export const Header = styled.div`
    ${flex}
    padding: 0 8px;
    line-height: 36px;
    justify-content: space-between;
    background-color: var(--color-gray-100);
    gap: 8px;
`

export const HeaderLeft = styled.div`
    /* width: 126px; */
    ${flex}
    align-items: center;
    overflow: hidden;
    flex: 1;
`

export const Handle = styled.div`
    /* padding: 4px; */
    ${flex}
    align-items: center;
`

export const RightFill = styled.div`
    width: 180px;
    /* max-width: 80%; */
    ${flex}
    justify-content: flex-end;
    align-items: center;
    gap: 7px;
`

export const Content = styled.div`
    margin: 16px 0;
`

export const Condition = styled.div`
    ${flex}
    gap: 4px;
    align-items: center;
    white-space: nowrap;
    color: var(--color-gray-900);
    font-size: 14px;
    font-weight: 400;
`

export const Title = styled.span`
    font-style: normal;
    word-break: break-word;
    margin: 0 6px;
    ${singleTextEllipsis};
    display: inline-block;
    min-width: 40px;
    font-size: 12px;
    color: var(--color-gray-600);
    background: var(--color-white);
    border: 1px solid var(--color-gray-200);
    border-radius: 4px;
    line-height: 22px;
    padding: 1px 4px;
`
